/**
 * Setup
 */
var baseurl = 'http://amarsul.com/';
//var baseurl = 'http://amarsul.lvarela.com/';
var imgurl = 'http://amarsul.com/';

global.jQuery = require('jquery');
var $ = window.$ = global.$ = global.jQuery;
var jQuery = $;
var _ = require('lodash');
var angular = require('angular');


window.$ = $;
window.jQuery = $;

require('bootstrap');
require('jquery-placeholder');
require('./polyfill')();
require('slick-carousel');
require('angular-slick');
require('angular-bootstrap-lightbox');
require('angular-toastr');

var _cacheBusterDate = new Date().toISOString().replace(/\D/g, "").slice(0, 10);//YYYYMMDDHH

var myApp = angular.module('myApp', ['slick', 'bootstrapLightbox', require('angular-route'), require('angular-ui-bootstrap'),'toastr']);

myApp.config(['$routeProvider', '$locationProvider', 'LightboxProvider','toastrConfig',
    function ($routeProvider, $locationProvider, LightboxProvider, toastrConfig) {
        $locationProvider.hashPrefix('');

        $('input, textarea').placeholder();

        LightboxProvider.templateUrl = '/lightbox.html';

        $routeProvider
                .when('/amarsul', {access: ['amarsul', 'municipios']})
                .when('/municipios', {access: ['municipios']})
                .otherwise({access: []});
        
        angular.extend(toastrConfig, {
            closeButton: true,
            tapToDismiss: false,
            extendedTimeOut: 360000000,
            timeOut: 360000000,
            autoDismiss: true,
            maxOpened: 1
        });
    }]);


require('./slider/')(myApp, imgurl);


/**
 * Data Factory
 */
myApp.factory('ecopontos', ['$http', '$q', function ($http, $q) {
        var deferred = $q.defer();
        
        $http.get('/ecopontos.json?t='.concat(_cacheBusterDate)).then(function (res) {
            deferred.resolve(res.data);
        }, function (response) {
            deferred.resolve([]);
        });

        return deferred.promise;
    }]);

/**
 * Data Factory
 */
myApp.factory('pontospap', ['$http', '$q', function ($http, $q) {
        var deferred = $q.defer();

        $http.get('/pontos_pap.json?t='.concat(_cacheBusterDate)).then(function (res) {
            deferred.resolve(res.data);
        }, function (response) {
            deferred.resolve([]);
        });

        return deferred.promise;
    }]);

/**
 * Data Factory
 */
myApp.factory('pontos1100', ['$http', '$q', function ($http, $q) {
        var deferred = $q.defer();

        $http.get('/pontos_1100l.json?t='.concat(_cacheBusterDate)).then(function (res) {
            deferred.resolve(res.data);
        }, function (response) {
            deferred.resolve([]);
        });

        return deferred.promise;
    }]);

/**
 * Data Factory
 */
myApp.factory('imagenspontos', ['$http', '$q', function ($http, $q) {
        var deferred = $q.defer();

        $http.get('/images.json?t='.concat(_cacheBusterDate)).then(function (res) {
            deferred.resolve(res.data);
        }, function (response) {
            deferred.resolve([]);
        });

        return deferred.promise;
    }]);

/**
 * Google maps
 */
myApp.factory('google', ['$q', function ($q) {
        var deferred = $q.defer();

        var GoogleMapsLoader = require('google-maps');
        GoogleMapsLoader.KEY = 'AIzaSyALQoonBSXW9cRYMHkR-QodD4ShSECBNBw';
        GoogleMapsLoader.VERSION = '3.35';
        GoogleMapsLoader.LANGUAGE = 'pt';
        GoogleMapsLoader.LIBRARIES = ['places'];
        var options = {
            center: {lat: 38.61472, lng: -8.907353}, 
            zoom: 11,
            disableDoubleClickZoom: true
        };

        GoogleMapsLoader.load(function (g) {
            deferred.resolve({
                google: g,
                map: new g.maps.Map(document.getElementById('map-canvas'), options)
            });
        });

        return deferred.promise;
    }]);


/**
 * Main Controller
 */
myApp.controller('MainController', ['$scope', 'ecopontos', 'pontospap', 'pontos1100', 'imagenspontos', 'google', '$q', '$timeout', '$route', '$compile', 'toastr',
    function ($scope, ecopontos, pontospap, pontos1100, imagenspontos, google, $q, $timeout, $route, $compile, toastr) {
        $scope.layers = [];
        $scope.search = '';
        $scope.circuito = '';

        var refreshfcn = [];

        //wait for data and google maps to be ready
        $q.all([ecopontos, google, pontospap, pontos1100, imagenspontos]).then(function (data) {
            $scope.google = data[1].google;
            $scope.map = data[1].map;

            var _order = 0;
            $scope.municipios = _.map(_.sortBy(_.filter(_.uniq(_.map(data[0], 'con')), function (c) {
                return !!c;
            })), function (m) {
                return {name: m, visible: true, order: ++_order};
            });

            $scope.municipios.unshift({name: 'Mostrar/Ocultar', visible: true, order: 0});

            $scope.map.addListener('bounds_changed', function (e) {
                if ($scope.map
                        && $scope.info
                        && $scope.info.getPosition() !== null
                        && typeof $scope.info.getPosition() === 'object'
                        && !$scope.map.getBounds().contains($scope.info.getPosition())) {
                    $scope.info.close();
                }
            });

            $scope.images = data[4];
            
            require('./doubleclick/setup')($scope, toastr, $scope.map, $compile);
            
            refreshfcn.push(require('./layers/setup')($scope, baseurl, 'PaP', 'PaP', $scope.municipios, $scope.map, $scope.google, 'municipios'));
            refreshfcn.push(require('./layers/setup')($scope, baseurl, 'PaP_Expansao', 'PaP – Expansão', $scope.municipios, $scope.map, $scope.google, 'municipios'));
            refreshfcn.push(require('./layers/setup')($scope, baseurl, '1100L', '1100L', $scope.municipios, $scope.map, $scope.google, 'municipios'));
            refreshfcn.push(require('./layers/setup')($scope, baseurl, '1100L_Expansao', '1100L – Expansão', $scope.municipios, $scope.map, $scope.google, 'municipios'));
            refreshfcn.push(require('./layers/setup')($scope, baseurl, 'ReforcoEcopontos', 'Reforço Ecopontos', $scope.municipios, $scope.map, $scope.google, 'municipios'));
            refreshfcn.push(require('./search/setup')($scope, $compile, $scope.map, $scope.google));
            refreshfcn.push(require('./ecopontos/setup')($scope, data[0], $scope.map, $scope.google, $timeout, $compile));
            refreshfcn.push(require('./pontospap/setup')($scope, data[2], $scope.map, $scope.google, $timeout, $compile));
            refreshfcn.push(require('./pontos1100/setup')($scope, data[3], $scope.map, $scope.google, $timeout, $compile));
        });



        $scope.$on("$routeChangeSuccess", function (currentRoute, previousRoute) {
            $scope.access = $route.current.access;
            refresh();
        });

        $scope.is = function (name) {
            return _.indexOf($scope.access, name) !== -1;
        };

        //each time there is a change in the filters
        var refresh = function () {
            _.each(refreshfcn, function (r) {
                r();
            });
        };
        var _previousAll = true;
        var refreshMun = function () {
            if (_previousAll !== $scope.municipios[0].visible) {
                _previousAll = $scope.municipios[0].visible;
                var index = 0;
                for (index = 1; index < $scope.municipios.length; ++index) {
                    $scope.municipios[index].visible = _previousAll;
                }
            }
            refresh();
        };

        $scope.$watch('municipios', refreshMun, true);
        $scope.$watch('access', refresh, true);
        $scope.$watch('layers', refresh, true);
        $scope.$watch('search', refresh, true);
        $scope.$watch('circuito', refresh, true);

        $scope.keyEvent = function ($event) {
            if ($event.which === 13) {
                $timeout(function () {
                    var bounds = new $scope.google.maps.LatLngBounds();
                    var hasVisible = false;

                    //cycle pappontos
                    _.each(_.filter($scope.pontos, {'visible': true}), function (e) {
                        bounds.extend(e.marker.position);
                        hasVisible = true;
                    });

                    //cycle pontos1100
                    _.each(_.filter($scope.pontos1100, {'visible': true}), function (e) {
                        bounds.extend(e.marker.position);
                        hasVisible = true;
                    });

                    //cycle ecopontos
                    _.each(_.filter($scope.ecopontos, {'visible': true}), function (e) {
                        bounds.extend(e.marker.position);
                        hasVisible = true;
                    });


                    if (!hasVisible) {
                        alert('Não foi possivel encontrar nenhum ponto que corresponda à pesquisa efectuada');
                    } else {
                        $scope.map.fitBounds(bounds);
                    }
                }, 200); //give time to refresh visibility
            }
        }

    }]);



// WEBPACK FOOTER //
// ./src/main.js